import { rootObsApi } from "./observe";
import { rootMmcApi } from "./controlPlane";
import { rootKMSApi } from "./kms";
import { rootOprApi } from "./operator";
import { rootDpvApi } from "./directpv";
import { rootFwApi } from "./firewall";
import { rootNodeApi } from "./node";
import { rootObsRpcApi } from "./observeRpc";
import { rootKmsRpcApi } from "./kmsRpc";
import { rootCatApi } from "./catalog";
import { rootIngressApi } from "./ingress";
import { rootCacheApi } from "./cache";
import { rootBackendApi } from "./enterprise";
import { rootCnsApi } from "./console";

export let api = rootMmcApi;
export let cnsApi = rootCnsApi;
export let obsApi = rootObsApi;
export let obsRpc = rootObsRpcApi;
export let kmsApi = rootKMSApi;
export let oprRpc = rootOprApi;
export let dpvRpc = rootDpvApi;
export let fwRpc = rootFwApi;
export let nodeRpc = rootNodeApi;
export let catRpc = rootCatApi;
export let kmsRpc = rootKmsRpcApi;
export let ingressRpc = rootIngressApi;
export let cacheRpc = rootCacheApi;
export let backendRpc = rootBackendApi;
